import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { SocialProof } from './SocialProof';
export function HeroSection() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy-dark py-10 md:py-24 px-4 relative overflow-hidden" data-id="element-37">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-38"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-39">
        <motion.h1 className="text-2xl md:text-5xl font-black text-white mb-6 md:mb-10 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-40">
          Dejá de terminar tu día agotado y resolvé la gestión de tu estudio en
          minutos
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-5 md:mb-8 cursor-pointer relative group inline-block" onClick={scrollToCompra} data-id="element-41">
          <div className="absolute inset-0 bg-gold/20 blur-xl rounded-full group-hover:bg-gold/30 transition-all duration-300" data-id="element-42"></div>
          <img src="https://cdn.magicpatterns.com/uploads/kGN58kiv3aS6NYxD8nYWVs/MOCKUP_PNG.png" alt="Estudio Jurídico Listo" className="w-[65%] md:w-[70%] max-w-lg mx-auto relative z-10 drop-shadow-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-43" />
        </motion.div>

        <motion.div className="mb-6 md:mb-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} data-id="element-44">
          <p className="text-base md:text-xl text-gray-300 font-medium mb-1" data-id="element-45">
            Sistema completo de gestión eficiente para estudios jurídicos.
          </p>
          <p className="text-lg md:text-2xl font-bold" data-id="element-46">
            <span className="text-gold" data-id="element-47">Ahorrá hasta una hora diaria</span>{' '}
            <span className="text-white" data-id="element-48">con este pack</span>
          </p>
        </motion.div>

        <CTAButton data-id="element-49" />
        <SocialProof data-id="element-50" />
      </div>
    </section>;
}